<template>
    <div style="position: relative;">
        <div v-if="!isDetail && !hideProfile" style="">
            <div style="display: flex; gap: 8px; align-items: center;">
                <div @click="showProfile($event)">
                    <ProfileImage :imagePath="isReportList ? myImage : soccerHows.image_path" style="width: 40px;"></ProfileImage>
                </div>
                <div @click="showProfile($event)" style="width:100%;">
                    <div style="font-weight: 700; font-size: 12px; margin-bottom: 4px;width:100%;position:relative;">
                        {{ isReportList ? $GlobalStore.loginInfo().nic_name : soccerHows.nic_name }}
                        <span style="color: var(--color-main);">
                            <DivisionPositionText :positionProAbility="isReportList ? $GlobalStore.loginInfo().position_pro_ability : soccerHows.position_pro_ability" :position="isReportList ? $GlobalStore.loginInfo().position : soccerHows.position"></DivisionPositionText>
                        </span>
                        <span v-if="$hasOwnProperty(soccerHows, 'activity_ranking')" style="position:absolute;right:0px; top:-2px;"><span style="font-size:10px;">{{ soccerHows.activity_ranking ? '활동량 랭킹' : '활동량' }}</span><span style="color:var(--color-main); font-size:14px; margin-left:3px;">{{ soccerHows.activity_ranking ? soccerHows.activity_ranking + '위' : (soccerHows.step_count * 7.0 / 10000).toFixed(1) + 'km' }}</span></span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color:#210F03; opacity: 0.7;">
                        {{ isReportList ? $GlobalStore.loginInfo().place_name : transPlaceName }}
                        <span v-if="transPlaceName !== ''" style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                        {{ soccerHows.insert_date | agoDateStr }}
                    </div>
                </div>
                <div style="flex:1;"></div>
            </div>
        </div>
        <div :style="{ marginLeft: isDetail || hideProfile ? '' : '46px' }" @click="showTrainingRequestDetail" style=" border-radius: 12px; margin-left: 46px;">
            <!-- <div :style="{ backgroundColor: isFeed ? '#A0C6FF' : '#ffcaa6' }" style="display: inline-block; line-height: 16px; font-weight: 700; font-size: 14px; border-radius: 20px; padding: 8px 12px;">{{ transText(soccerHows.type) }}</div> -->
            <div style="font-weight: 500; font-size: 15px; line-height: 32px; margin-bottom: 8px; word-break: break-all; white-space: pre-line;">
                {{ contents }}
            </div>
            <div class="hide_scroll" style="display: flex; overflow-x: scroll; margin-left: -58px; margin-right: -12px; padding-left: 58px; padding-right: 12px; gap: 12px;">
                <div v-if="youtubeLink !== ''" style="background-color: black; width: 200px; height: 200px; border-radius: 12px; display: flex; flex-shrink: 0; flex-direction: column; justify-content: center; margin-bottom: 16px;">
                    <div @click.stop="showVideoDetailYoutube(youtubeLink)" style="border-radius:12px; flex-shrink: 0; width: 100%; overflow:hidden; position: relative;">
                        <!-- <ContentsViewer paddingBottom="66%" :contents="youtubeLink" style="" /> -->
                        <img style="object-fit: cover; width: 100%; height: 100%;" :src="youtubeThumbImage">
                        <div @click.stop="showVideoDetailYoutube(youtubeLink)" style="position: absolute; z-index: 1; transform: translate(-50%, -50%); left: 50%; top: 50%;">
                            <img style="width: 52px;" :src="require('@/assets/youtube_icon.png')" alt="">
                        </div>
                    </div>
                </div>
                <template v-if="isShowImage">
                    <div v-for="each, i in imgSrcArr" :key="i" :style="{ width: each.width, height: each.height }" style="flex-shrink: 0; border-radius: 12px; overflow: hidden; margin-bottom: 16px;">
                        <template v-if="!each.videoPath.isVideo">
                            <InteractionOfScale style="width: 100%; height: 100%;">
                                <img @click.stop="showImageDetail(i)" style="object-fit: cover; width: 100%; height: 100%; border-radius: 12px;" :ref="'img' + i" :src="each.path">
                            </InteractionOfScale>
                        </template>
                        <div @click.stop="() => { }" style="position: relative; width: 100%; height: 100%;" v-else>
                            <img @click.stop="showVideoDetail(each.path, each.videoPath.thumbnail_path)" style="object-fit: cover; width: 100%; height: 100%;" :ref="'img' + i" :src="$resourcePath + each.videoPath.thumbnail_path">
                            <div @click.stop="showVideoDetail(each.path, each.videoPath.thumbnail_path)" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                <img style="width: 40px;" :src="require('@/assets/video_play_icon.png')" alt="">
                            </div>
                            <!-- <div style="background-color: transparent; position: absolute; width: 100%; height: 100%; border-radius: 12px; z-index: 10;"></div>
                            <video ref="videoPlayer" @play="goFullScreen" :poster="$resourcePath + each.videoPath.thumbnail_path" controls style="border-radius: 12px; position: relative; width: 100%; height: inherit;">
                                <source style="" :src="each.path" type="video/mp4">
                            </video> -->
                        </div>
                    </div>
                </template>
            </div>
            <!-- <div v-else style="display: flex; overflow-x: scroll; gap: 4px; position: absolute; right: 0; top: 0;">
                <div v-if="youtubeLink !== ''" style="background-color: black; width: 40px; height: 40px; border-radius: 8px; display: flex; flex-shrink: 0; flex-direction: column; justify-content: center; border: 1px solid #d9d9d9;">
                    <div @click.stop="showVideoDetailYoutube(youtubeLink)" style="border-radius:12px; flex-shrink: 0; width: 100%; overflow:hidden; position: relative;">
                        <img style="object-fit: cover; width: 100%; height: 100%;" :src="youtubeThumbImage">
                        <div @click.stop="showVideoDetailYoutube(youtubeLink)" style="position: absolute; z-index: 10; transform: translate(-50%, -50%); left: 50%; top: 50%;">
                            <img style="width: 20px;" :src="require('@/assets/youtube_icon.png')" alt="">
                        </div>
                    </div>
                </div>
                <template v-if="isShowImage">
                    <div v-for="each, i in imgSrcArr" :key="i" style="flex-shrink: 0; border-radius: 8px; width: 40px; height: 40px; overflow: hidden; border: 1px solid #d9d9d9;">
                        <img @click.stop="showImageDetail(i)" v-if="!each.videoPath.isVideo" style="object-fit: cover; width: 100%; height: 100%;" :ref="'img' + i" :src="each.path">
                        <div @click.stop="() => { }" style="position: relative; width: 100%; height: 100%;" v-else>
                            <img @click.stop="showVideoDetail(each.path, each.videoPath.thumbnail_path)" style="object-fit: cover; width: 100%; height: 100%;" :ref="'img' + i" :src="$resourcePath + each.videoPath.thumbnail_path">
                        </div>
                    </div>
                </template>
            </div> -->
            <div v-if="isDetail && soccerHows.update_date && !isChat" style="font-weight: 400; font-size: 12px; color: #808080; margin-bottom: 16px;">수정됨</div>
            <div v-if="!isChat" :style="{ marginLeft: isDetail ? '16px' : '' }" style="display: flex; align-items: center; position: relative;">
                <div style="display: flex; gap: 16px; align-items: center; flex: 1;">
                    <div @click.stop="toggleTouch" style="display: flex; gap: 5px; align-items: center; ">
                        <div style="position: relative;">
                            <img :style="{ opacity: curLikeYn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                            <img style="width: 16px; position: relative; z-index: 2;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                            <!-- <img v-else style="width: 16px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt=""> -->
                        </div>
                        <div style="font-weight: 700; font-size: 12px;">{{ curLikeNumber }}</div>
                    </div>
                    <div v-if="[SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING].indexOf(soccerHows.type) > -1" style="display: flex; gap: 5px; align-items: center;">
                        <img style="width: 16px;" :src="require('@/assets/img/feed_reply.png')" alt="">
                        <div style="font-weight: 700; font-size: 12px;">{{ soccerHows.reply_number }}</div>
                    </div>
                    <div style="display: flex; gap: 5px; align-items: center;">
                        <img style="width: 16px;" :src="require('@/assets/img/request_icon.png')" alt="">
                        <div style="font-weight: 700; font-size: 12px;">{{ (soccerHows.alarm_cnt ? soccerHows.alarm_cnt : 0) | comma }}</div>
                    </div>
                </div>
                <div v-if="$GlobalStore.isLogin() && !hideOption" @touchstart.stop="() => { }" @touchend.stop="() => { }" @click.stop="showPopupMenu" style="display: flex; gap: 3px; height: 30px; justify-content: end; width: 40px; align-items: center; position: absolute; right: 0;">
                    <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #606060;"></div>
                    <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #606060;"></div>
                    <div style="width: 5px; height: 5px; border-radius: 50%; background-color: #606060;"></div>
                </div>
            </div>
        </div>
        <!-- <div v-if="isNeedRecommendSection && $GlobalStore.isLogin()" style="padding-top: 20px; margin: 0 -12px; border-top: 1px solid #f5f5f5; margin-top: 20px;">
            <div style="margin-left: 12px; margin-bottom: 20px; font-size: 14px; font-weight: 700;">{{ $GlobalStore.loginInfo().is_temp_coach == 1 ? $GlobalStore.loginInfo().name + '님에게 딱 맞는 선수 추천' : '친구 추천' }}</div>
            <RecommendFriendsWrapper :userList="recommendUserList"></RecommendFriendsWrapper>
        </div> -->
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <template v-if="formFlag">
            <MakeRequestJoinForm :soccerhowIdx="soccerHows.idx" :mode="'update'" :isLearn="isFeed" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        </template>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { MAIN_TYPE, SOCCER_HOW_TYPE, REPORT_TYPE_IDX } from '@/Constants'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm';
import InteractionOfScale from '@/components/common/InteractionOfScale';
import DivisionPositionText from '@/components/common/DivisionPositionText'
// import RecommendFriendsWrapper from '@/components/common/RecommendFriendsWrapper'
// import ContentsViewer from '@/components/common/ContentsViewer'

const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export default {
    name: 'CommonPost',
    components: { ProfileImage, DivisionPositionText, BottomPopupMenu, MakeRequestJoinForm, InteractionOfScale },
    props: {
        // isFeed = true => 축구 배우기
        isFeed: {
            type: Boolean,
            default: false
        },
        soccerHows: {
            type: Object,
            default: () => { }
        },
        isDetail: {
            type: Boolean,
            default: false
        },
        isExpert: {
            type: Boolean,
            default: false
        },
        isExpertConfirmed: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Function,
            default: () => { }
        },
        isPopular: {
            type: Boolean,
            default: false
        },
        isChat: {
            type: Boolean,
            default: false
        },
        hideOption: {
            type: Boolean,
            default: false
        },
        isReportList: {
            type: Boolean,
            default: false
        },
        isNeedWrittenCheck: {
            type: Boolean,
            default: false
        },
        isRealTime: {
            type: Boolean,
            default: false
        },
        isNeedRecommendSection: {
            type: Boolean,
            default: false
        },
        recommendUserList: {
            type: Array,
            default: () => {}
        },
        preventClick: {
            type: Boolean,
            default: false
        },
        clickEvent: {
            type: Function,
            default: () => {}
        },
        hideProfile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            MAIN_TYPE: MAIN_TYPE,
            youtubeLink: '',
            contents: '',
            imgSrcArr: [],
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            isShooting: false,
            IS_LIKE: IS_LIKE,
            copySoccerHows: {},
            isShowImage: false,
            windowWidth: 0,
            mediaWidth: 0,
            mediaHeight: 0,
            youtubeThumbImage: null,
            isShowPopMenu: false,
            menuOptions: {},
            isShowMakeRequestJoinForm: false,
            isShowBookmarkPopupReport: false,
            formFlag: false
        }
    },
    methods: {
        showProfile(e) {
            if (this.preventClick) {
                return
            } else {
                e.stopPropagation()
            }
            if (this.$GlobalStore.isLogin()) {
                if (this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                    if (this.isPopular) {
                        this.$Util.sendEventClick('인기글_프로필조회', true)
                    } else if (this.isRealTime) {
                        this.$Util.sendEventClick('실시간게시물_프로필조회', true)
                    } else if (!this.isFeed) {
                        this.$Util.sendEventClick('축구팀입단_프로필조회', true)
                    }
                } else {
                    if (!this.isFeed) {
                        this.$Util.sendEventClick('전문가회원_축구팀입단_프로필조회', true)
                    }
                }
            }
            this.$Util.showProfile(this.soccerHows.writer_idx, this.soccerHows.writer_type)
        },
        report() {
            this.$Util.sendEventClick('사커하우_게시물신고')

            let report_refer_type = '';

            if ([SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING].indexOf(this.soccerHows.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_TRAINING;
            } else if ([SOCCER_HOW_TYPE.SC_JOB, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_COUNSEL].indexOf(this.soccerHows.type) > -1) {
                report_refer_type = REPORT_TYPE_IDX.SOCCERHOW_REQUEST;
            }

            this.$GlobalStore.addModal('ReportPopup',
                {
                    target_member_idx: this.$GlobalStore.loginInfo().idx,
                    target_member_type: this.soccerHows.writer_type,
                    refer_type: report_refer_type,
                    refer_idx: this.soccerHows.idx,
                    report_title: this.soccerHows.title,
                    report_contents: this.soccerHows.contents
                }
            );
        },
        async deleteSoccerhow() {
            if (confirm('삭제 하시겠습니까?')) {
                const res = await this.$Axios.post('/api/soccerhow/delete', { deleteList: [this.soccerHows.idx] });

                if (res.data.code === 0) {
                    this.refresh()
                    this.$GlobalStore.closeLastModal()
                }
            }
        },
        shareTrainingRequest() {
            const message = '';
            let url = ''

            if (process.env.NODE_ENV === 'development') {
                url = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    url = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    url = 'https://app.soccerhow.com';
                }
            }

            let mainType = this.isFeed ? MAIN_TYPE.SOCCER_LEARN : MAIN_TYPE.SOCCER_TEAM_JOINING
            if (this.isPopular) {
                this.$Util.sendEventClick('인기글_공유하기', true)
            } else if (this.isRealTime) {
                this.$Util.sendEventClick('실시간게시물_게시글_공유하기', true)
            }
            url += '/training?type=' + (mainType === MAIN_TYPE.SOCCER_LEARN ? 'learn' : 'request') + '&idx=' + this.soccerHows.idx;
            // console.log(url);
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        closeRequestJoinForm(isModify) {
            if (isModify) {
                this.refresh()
            }
            this.isShowMakeRequestJoinForm = false
            setTimeout(() => {
                this.formFlag = false
            }, 510)
        },
        showPopupMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []

            if (this.isMeCreator) {
                labelAndAction.push(
                    {
                        label: '수정하기', action: () => {
                            this.formFlag = true
                            setTimeout(() => {
                                this.isShowMakeRequestJoinForm = true;
                            }, 10)
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '삭제하기', action: () => {
                            this.deleteSoccerhow();
                            this.isShowPopMenu = false;
                        },
                    }
                );

                labelAndAction.push({
                    label: '공유하기', action: () => {
                        this.shareTrainingRequest();
                        this.isShowPopMenu = false;
                    },
                });
            } else {
                labelAndAction.push(
                    {
                        label: '프로필 보기', action: () => {
                            this.$Util.showProfile(this.soccerHows.writer_idx, this.soccerHows.writer_type, '', 0);
                            this.isShowPopMenu = false
                        },
                    }
                )
                labelAndAction.push(
                    {
                        label: '신고하기', action: () => {
                            this.report()
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '공유하기', action: () => {
                            this.shareTrainingRequest();
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        showVideoDetail(path, thumbnail_path) {
            if (this.preventClick) {
                this.clickEvent(this.soccerHows)
                return
            }
            if (this.isDetail) {
                this.$GlobalStore.addModal('VideoViewer', { urlPath: path, isYoutube: false, thumbnail_path: thumbnail_path, status_bar_text_color: 'white' })
            } else {
                this.showTrainingRequestDetail()
            }
        },
        showVideoDetailYoutube(path) {
            if (this.preventClick) {
                this.clickEvent(this.soccerHows)
                return
            }
            if (this.isDetail) {
                if (this.isPopular) {
                    this.$Util.sendEventClick('인기글_게시물상세_영상시청', true)
                } else if (this.isRealTime) {
                    this.$Util.sendEventClick('실시간게시물_게시물상세_영상시청', true)
                }
                this.$GlobalStore.addModal('VideoViewer', { urlPath: path, isYoutube: true, status_bar_text_color: 'white' })
            } else {
                this.showTrainingRequestDetail()
            }
        },
        // async goFullScreen() {
        //     const video = this.$refs.videoPlayer;
        //     console.log(video)
        //     if (video[0].requestFullscreen) {
        //         video[0].requestFullscreen();
        //     } else if (video[0].mozRequestFullScreen) { // Firefox
        //         video[0].mozRequestFullScreen();
        //     } else if (video[0].webkitRequestFullscreen) { // Chrome, Safari
        //         video[0].webkitRequestFullscreen();
        //     } else if (video[0].msRequestFullscreen) { // IE/Edge
        //         video[0].msRequestFullscreen();
        //     } else if (video[0].webkitEnterFullscreen) { // iOS 전용
        //         video[0].webkitEnterFullscreen();
        //     }

        //     if (screen.orientation && screen.orientation.lock) {
        //         try {
        //             await screen.orientation.lock("portrait");
        //         } catch (e) {
        //             console.warn("화면 방향 잠금 실패:", e);
        //         }
        //     }
        // },
        showImageDetail(index) {
            if (this.preventClick) {
                this.clickEvent(this.soccerHows)
                return
            }
            if (this.isDetail) {
                const imgSrcArr = []
                this.imgSrcArr.forEach(item => {
                    imgSrcArr.push(item.imageViewerPath)
                })
                this.$GlobalStore.addModal('ImageViewer', { imagePaths: imgSrcArr, initIndex: index })
            } else {
                this.showTrainingRequestDetail()
            }
        },
        async toggleLike() {
            const parameters = {};
            parameters.likeYn = this.curLikeYn === IS_LIKE.UNLIKE ? '0' : '1';
            parameters.idx = this.copySoccerHows.idx

            const res = await this.$Axios.post('/api/soccerhow/like', parameters);
            if (res.data.code === -1) {
                alert(res.data.msg);
            }
        },
        toggleTouch() {
            if (this.isReportList || !this.$GlobalStore.isLogin()) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
            }

            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.isReportList) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                setTimeout(() => {
                    this.$refs.soccerBall.style.transition = 'all 0.3s'
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                    this.$refs.shoot.style.opacity = '1'
                    this.$refs.shoot.style.transition = 'all 0.3s'
                }, 100)
            } else {
                setTimeout(() => {
                    this.$refs.shoot.style.transition = ''
                    this.$refs.shoot.style.opacity = '0'
                }, 100)
            }
            let likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            let likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            this.$set(this.copySoccerHows, 'like_yn', likeTemp);
            this.$set(this.copySoccerHows, 'like_number', likeNumber);
            this.setSendEventClick()
            this.toggleLike();
            this.$Util.vibrate();
        },
        touchStart(e) {
            e;
        },
        setSendEventClick() {
            if (this.isPopular) {
                if (this.isDetail) {
                    this.$Util.sendEventClick('인기글_게시물상세_좋아요', true)
                } else {
                    this.$Util.sendEventClick('인기글_게시물_좋아요', true)
                }
            } else if (this.isRealTime) {
                if (this.isDetail) {
                    this.$Util.sendEventClick('실시간게시물_게시물상세_좋아요', true)
                } else {
                    this.$Util.sendEventClick('실시간게시물_좋아요', true)
                }
            } else if (!this.isFeed) {
                if (this.isDetail) {
                    this.$Util.sendEventClick('축구팀입단_게시물상세_좋아요', true)
                } else {
                    this.$Util.sendEventClick('축구팀입단_게시물_좋아요', true)
                }
            }
        },
        touchEnd() {

        },
        transText(type) {
            if (type === SOCCER_HOW_TYPE.SINGLE_TRAINING) {
                return '🥅 개인훈련'
            } else if (type === SOCCER_HOW_TYPE.GROUP_TRAINING) {
                return '👬🏻 단체훈련'
            } else if (type === SOCCER_HOW_TYPE.SC_COUNSEL) {
                return '🤔 축구 진로 상담'
            } else if (type === SOCCER_HOW_TYPE.SC_JOIN) {
                return '🏟️ 축구팀 입단'
            } else if (type === SOCCER_HOW_TYPE.SC_JOB) {
                return '🏆 축구선수 희망'
            }
        },
        async showTrainingRequestDetail() {
            if (this.preventClick) {
                return
            }
            if (this.isDetail) {
                return
            }
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (!this.isExpertConfirmed && this.isExpert) {
                this.$GlobalStore.setIsShowBookmarkPopupNotExpert()
                return
            }

            if (this.isNeedWrittenCheck) {
                const isWrittenRequestForm = await this.$Util.checkIsWriteRequestForm()
                if (!isWrittenRequestForm && this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                    alert("최소 하나 이상의 입단 요청서를 작성해야 볼 수 있습니다")
                    return
                }
            }
            let mainType = this.isFeed ? MAIN_TYPE.SOCCER_LEARN : MAIN_TYPE.SOCCER_TEAM_JOINING
            if (this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                if (this.isPopular) {
                    this.$Util.sendEventClick('인기글_자세히보기', true)
                } else if (this.isRealTime) {
                    this.$Util.sendEventClick('사커하우_피드_자세히보기', true)
                } else if (mainType === MAIN_TYPE.SOCCER_TEAM_JOINING) {
                    this.$Util.sendEventClick('사커하우_요청서_자세히보기', true)
                }
            } else {
                if (mainType === MAIN_TYPE.SOCCER_TEAM_JOINING) {
                    this.$Util.sendEventClick('전문가회원_요청서_자세히보기', true)
                }
            }
            if (mainType === MAIN_TYPE.SOCCER_LEARN) {
                this.$GlobalStore.addModal('TrainingRequestDetail', { likeFromDetail: this.likeFromDetail, main_type: mainType, isModalBackTransparent: true, isExpert: this.isExpert, soccerhowIdx: this.soccerHows.idx, completeAction: this.refresh, isPopular: this.isPopular, isRealTime: this.isRealTime })
            } else {
                this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: this.soccerHows.idx, is_parent_verified: this.soccerHows.is_parent_verified })
            }
            // this.$Util.checkAppLinkPageShow();
        },
        getYoutubeLink() {
            if (this.$Util.getYoutubeLinkArr(this.soccerHows.contents)) {
                this.youtubeLink = this.$Util.getYoutubeLinkArr(this.soccerHows.contents)[0]
                this.contents = this.$Util.removeYoutubeLink(this.soccerHows.contents)
                const thumb_image = this.$Util.getYoutubeThumbnail(this.youtubeLink)
                this.youtubeThumbImage = thumb_image
            } else {
                this.contents = this.soccerHows.contents
            }
        },
        setImgSrgArr() {
            this.imgSrcArr = []
            const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'qt']; // 동영상 확장자 목록
            for (let i = 1; i < 4; i++) {
                const key = `media_path${i}`;
                const thumbnail_key = `thumbnail_path${i}`
                if (this.soccerHows[key]) {
                    const fullPath = this.$resourcePath + this.soccerHows[key];
                    this.imgSrcArr.push({
                        path: fullPath,
                        videoPath: {
                            isVideo: this.checkIfVideo(fullPath, videoExtensions),
                            thumbnail_path: this.soccerHows[thumbnail_key]
                        },
                        imageViewerPath: this.soccerHows[key],
                        width: '200px',
                        height: '200px'
                    });
                }
            }
            this.getImageSize()
        },
        getImageSize() {
            if (this.imgSrcArr.length === 1) {
                const img = new Image()
                if (this.imgSrcArr[0].videoPath.isVideo) {
                    img.src = this.$resourcePath + this.imgSrcArr[0].videoPath.thumbnail_path
                } else {
                    img.src = this.$resourcePath + this.imgSrcArr[0].imageViewerPath
                }
                img.onload = () => {
                    const imgWidth = img.naturalWidth
                    const imgHeight = img.naturalHeight

                    if (imgWidth > imgHeight) {
                        this.imgSrcArr[0].width = this.windowWidth * 0.82 + 'px'
                        this.imgSrcArr[0].height = this.windowWidth * 0.61 + 'px'
                    } else {
                        this.imgSrcArr[0].width = this.windowWidth * 0.66 + 'px'
                        this.imgSrcArr[0].height = this.windowWidth * 0.88 + 'px'
                    }
                }
                this.isShowImage = true
            } else {
                this.isShowImage = true
            }
        },
        checkIfVideo(path, videoExtensions) {
            const extension = path.split('.').pop().toLowerCase();
            return videoExtensions.includes(extension);
        },
        setCopySoccerHows() {
            this.copySoccerHows = this.soccerHows
        }
    },
    watch: {
        soccerHows: {
            handler(newVal) {
                this.setCopySoccerHows()
                if (newVal && Object.keys(newVal).length > 0) {
                    this.getYoutubeLink()
                    this.setImgSrgArr()
                }
            },
            deep: true,
        },
    },
    computed: {
        curLikeYn() {
            return parseInt(this.copySoccerHows.like_yn)
        },
        curLikeNumber() {
            return parseInt(this.copySoccerHows.like_number)
        },
        isMeCreator() {
            if (this.soccerHows.writer_idx == this.$GlobalStore.loginInfo().idx) {
                return true
            } else {
                return false
            }
        },
        myImage() {
            return this.$GlobalStore.loginInfo().image_path
        },
        transPlaceName() {
            if (this.soccerHows.place_name) {
                return this.soccerHows.place_name
            } else {
                return ''
            }
        }
    },
    created() {
        if (Object.keys(this.soccerHows).length > 0) {
            this.getYoutubeLink()
            this.setImgSrgArr()
        }
        this.windowWidth = window.screen.width
        if (this.windowWidth >= 600) {
            this.windowWidth = 600
        }
        this.mediaWidth = this.windowWidth * 0.82 + 'px'
        this.mediaHeight = this.windowWidth * 0.88 + 'px'
        // console.log(this.windowWidth)
        this.setCopySoccerHows()
    },

}
</script>

<style scoped>
.ellipsis_multiple_lines {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>